import React, {FC} from 'react';


import TableHeaderTitles from './TableHeaderTitles';
import TableFilters from './TableFilters';
import {AsyncFilters, FilterOptions, TableConfig, TableDataItem} from "../types";
interface TableHeaderProps {
  config: TableConfig;
  filterOptions?: FilterOptions;
  tableData: TableDataItem[];
  asyncFilters?: AsyncFilters;
  actionsNumber: number
}

const TableHeader: FC<TableHeaderProps> = ({ config, filterOptions, tableData, asyncFilters, actionsNumber }: TableHeaderProps) => {
  return (
    <>
      <TableHeaderTitles
        config={config}
        tableData={tableData}
        actionsNumber={actionsNumber}
      />
      { !config.disableFilters &&
        <TableFilters
          config={config}
          filterOptions={filterOptions}
          asyncFilters={asyncFilters}
          actionsNumber={actionsNumber}
        />
      }
    </>
  );
}
export default TableHeader